import { action, computed, observable } from 'mobx';
import { adminPartnerApi } from '@link/admin/services';
import {
  ContractWithOtaAndSupplier,
  ListContractsWithPageRequest,
  Ota,
  Contract as ContractType
} from '@link/admin/services/types';

export class Contract {
  @observable accessor contract: ContractWithOtaAndSupplier | null = null;
  @observable accessor otas: Ota[] = [];
  @observable accessor contracts: ContractWithOtaAndSupplier[] = [];

  @action
  async getList(params: ListContractsWithPageRequest) {
    const response = await adminPartnerApi.listContractsWithPage(params);
    this.setContracts(response.contracts || []);
    return response;
  }

  @action
  async getDetail(contractId: string) {
    const response = await adminPartnerApi.getContractDetail({
      contractId
    });
    if (response.contract) {
      this.setContract(response.contract);
    }
    return response;
  }

  @action
  setContract(contract: ContractWithOtaAndSupplier) {
    this.contract = contract;
  }
  @action
  setContracts(contracts: ContractWithOtaAndSupplier[]) {
    this.contracts = contracts;
  }

  @action
  async updateContract(contract: ContractType) {
    const response = await adminPartnerApi.addOrUpdateContract({
      body: { contract }
    });
    if (response.contractId) {
      this.setContract({ ...this.contract, ...contract });
    }
    return response;
  }

  @action
  async bulkAddContracts(contracts: ContractType[]) {
    const response = await adminPartnerApi.bulkAddContracts({
      body: { contracts }
    });
    return response;
  }

  @computed
  get status() {
    return this.contract?.status;
  }

  @computed
  get supplierId() {
    return this.contract?.supplier?.supplierId;
  }

  @computed
  get otaId() {
    return this.contract?.ota?.otaId;
  }

  @action
  clear() {
    this.contract = null;
  }
}

export default new Contract();
